import { Component, Injector, Input, Optional } from '@angular/core';

import { kpCertificaatService } from 'src/app/core/service/kp-certificaat.service';
import { kpCertificaat } from 'src/app/core/dto/kp-certificaat';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Instrument } from 'src/app/core/dto/instrument';

@Component({
    selector: 'c-i-j-borculokp-certificaat-collection',
    templateUrl: './kp-certificaat-collection.component.html'/*,
    styleUrls: ['./kp-certificaat-collection.component.css'] */
})
export class kpCertificaatCollectionComponent extends PagedCollectionComponent<kpCertificaat> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<kpCertificaat>([
		{ colDef: 'certificaat', prop: x => x.certificaat, searchable: SearchableType.String },
		{ colDef: 'datumKalibratie', prop: x => x.datumKalibratie, searchable: SearchableType.Date },
		{ colDef: 'justering', prop: x => x.justering, searchable: SearchableType.Boolean },
		{ colDef: 'afkeur', prop: x => x.afkeur, searchable: SearchableType.Boolean },
		{ colDef: 'status', prop: x => x.status, searchable: SearchableType.String }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: kpCertificaatService, @Optional() protected filter: Filter<kpCertificaat>, injector: Injector) {
        super('/kpCertificaat/kpCertificaat', injector, kpCertificaat);

        this.initInput('instrument', this.filterBuilder.equal(x => x.instrument));
        this.orderBy=[-2];

        this.filter.onGetChipLabel(x => x.certificaat, () => 'Certificaat');
		this.filter.onGetChipLabel(x => x.datumKalibratie, () => 'Datum Kalibratie');
		this.filter.onGetChipLabel(x => x.justering, () => 'Justering');
		this.filter.onGetChipLabel(x => x.afkeur, () => 'Afkeur');
		this.filter.onGetChipLabel(x => x.status, () => 'Status');
    }

	@Input() set instrument(val: Instrument) {
        this.handleInput('instrument', val.id);
		
    }
}